import BarChart from "./bar-chart";
export default BarChart;
